module.exports = __webpack_public_path__ + "img/logo_mini.67131b97.png";